module.exports = __webpack_public_path__ + "img/logo_ch.8fc0ddfa.svg";